<div class="card card-w-title">
    <!-- <h1><strong>{{titulo}}</strong></h1> -->

    <!-- Filtros -->
    <p-panel header="Buscar" [toggleable]="true" [style]="{'margin-bottom':'20px'}">
        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-6">
                <input type="text" pInputText placeholder="Ingresar apellidos y nombres" size="100" [(ngModel)]="descripcionFind" (keyup.enter)="onToBuscar()" />
            </div>
            <div class="ui-g-12 ui-md-3">
                <button pButton type="button" label="{{globalConstants.cBuscar}}" icon="{{globalConstants.icoBuscar}}" (click)="onToBuscar()" class="btn btn-block"></button>
            </div>
            <div class="ui-g-12 ui-md-3">
                <button [disabled]="buttonAcces.btnNuevo" pButton type="button" label="{{globalConstants.cNuevo}}" icon="{{globalConstants.icoNuevo}}" (click)="onToCreate()"></button>
            </div>
        </div>
    </p-panel>

    <!-- Grilla de Datos     -->
    <p-panel header="Lista de Usuarios" >
        <p-table [value]="listModelo" [columns]="columnas" [paginator]="true" [rows]="globalConstants.sizePage" dataKey="idPersona" editMode="row" autoLayout="true" [responsive]="true">
            <!-- Header -->
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>ID</th>
                    <th>USUARIO</th>
                    <th>APELLIDOS Y NOMBRES</th>
                    <th>PERFIL</th>
                    <th>ESTADO</th>
                    <th colspan="2">ACCIONES</th>
                </tr>
            </ng-template>
            <!-- body -->
            <ng-template pTemplate="body" let-modelo let-editing="editing" let-ri="rowIndex">
                <tr>
                    <td class="action-td">
                        <span class="ui-column-title">ID</span> {{modelo.idPersona}}
                    </td>
                    <td class="action-td">
                        <span class="ui-column-title">Usuario</span> {{modelo.usuario}}
                    </td>

                    <td class="ui-fluid">
                        <span class="ui-column-title">Apellidos y Nombres</span> {{modelo.nombreCompleto}}
                    </td>
                    <td class="action-td-thrre">
                        <span class="ui-column-title">Perfil</span> {{modelo.descripcionPerfil}}
                    </td>
                    <td class="action-td">
                        <span class="ui-column-title">Activo</span>
                        <p-checkbox [(ngModel)]="modelo.flgActivo" [binary]="true" [disabled]="true"></p-checkbox>
                    </td>
                    <td class="action-td">
                        <button [disabled]="buttonAcces.btnEditar" pButton icon="{{globalConstants.icoEditar}}" class="ui-button-success" (click)="onToRowSelectEdit(modelo)"></button>
                    </td>
                    <td class="action-td">
                        <button [disabled]="buttonAcces.btnEliminar" pButton icon="{{globalConstants.icoEliminar}}" class="ui-button-danger" (click)="onToRowSelectDelete(modelo)"></button>
                    </td>
                </tr>
            </ng-template>

        </p-table>
        <!-- <p-footer>
        </p-footer> -->
    </p-panel>
</div>

<!-- Para Eliminar -->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>